<template>
	<div>
		<v-form ref="form" class="agency-budget">
			<egranty-section-divider
				icon="attach_money"
				:text="'Budżet (w ' + currencyCode + ')'"
			/>


			<v-layout row wrap>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Działania</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Nazwa wydatku</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Środki z
							MSZ</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">
							<strong>Paragraf</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Środki z innych źródeł</strong></v-card-text>
					</v-card>
				</v-flex>

				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Wszystkie źródła</strong></v-card-text>
					</v-card>
				</v-flex>
			</v-layout>

			<v-layout  v-for="(cost,index) in costs" :key="index">
				<v-flex d-flex xs4>
					<v-card class="agency-actions-costs-layout" color="grey lighten-5" style="width: 100%">
						<v-layout  row wrap align-center>
							<div class="agency-action-costs-v-select-icon">
								<v-select
									class="ma-2 cost-name"
									:disabled="readonly"
									:items="actions"
									label="Działanie, którego dotyczy koszt"
									item-value="id"
									item-text="action"
									aria-label="action"
									v-model="cost.actionId"
									@input="sync"
									:data-vv-name="'actions' + index"
									data-vv-as="Działania"
									:error-messages="vErrors.collect('actions' + index)"
									v-validate="'required'"

								></v-select>
								<egranty-icon-button
									v-if="!readonly"
									color="lightred"
									icon="delete"
									label="Usuń to działanie"
									@click="removeCost(index)"
								></egranty-icon-button>
							</div>
						</v-layout>
					</v-card>
				</v-flex>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-5" style="width: 100%">
						<div class="ma-2">
							<egranty-text-input-field
								:disabled="readonly"
								:required="false"
								:textarea="true"
								:max-length="255"
								v-model="cost.expenseName"
								label="Nazwa wydatku"
								@input="sync"
							></egranty-text-input-field>
						</div>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-5">
						<div class="ma-2">
							<egranty-number-input-field
								class="amount"
								:disabled="readonly"
								v-model="cost.mszFundings"
								:label="currencyCode === '' ? 'kwota w PLN' : 'kwota w ' + currencyCode"
								@input="sync"
							></egranty-number-input-field>
						</div>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-5" width="100%">
						<v-select
							class="ma-2 amount paragraph-amount"
							:disabled="readonly"
							:items="paragraphs"
							label="Paragraf"
							aria-label="paragraph"
							item-value="id"
							item-text="name"
							v-model="cost.paragraphId"
							@input="sync"
							:data-vv-name="'paragraph' + index"
							data-vv-as="Paragraf"
							:error-messages="vErrors.collect('paragraph' + index)"
							v-validate="'required'"
						></v-select>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-5">
						<div class="ma-2">
							<egranty-number-input-field
								class="amount"
								:disabled="readonly"
								v-model="cost.ownFundings"
								:label="currencyCode === '' ? 'kwota w PLN' : 'kwota w ' + currencyCode"
								@input="sync"
							></egranty-number-input-field>
						</div>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-5">
						<div class="ma-2 total-funding">
							{{calculateTotalFundingForCost(cost)}}
						</div>
					</v-card>
				</v-flex>
			</v-layout>

			<div v-for="paragraph in paragraphs" :key="paragraph.arrayId">
				<v-layout v-if="paragraph.totalFundings">
					<v-flex d-flex xs4>
						<v-card color="grey lighten-1">
							<v-layout row>
								<v-card-text style="padding-right: 8px"><strong>Suma ({{paragraph.name}})</strong>
								</v-card-text>
							</v-layout>
						</v-card>
					</v-flex>
					<v-flex d-flex xs4>
						<v-card color="grey lighten-1">
							<v-card-text></v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-1">
							<v-card-text class="amount" style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>{{formatMoney(paragraph.totalMszFundingsForParagraph)}}</strong>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-1">
							<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-1">
							<v-card-text class="amount">
								<strong>{{formatMoney(paragraph.totalOwnFundingsForParagraph)}}</strong>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-1">
							<v-card-text class="amount" >
								<strong>{{formatMoney(paragraph.totalFundings)}}</strong>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</div>
			<v-layout row wrap>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-right: 8px"><strong>Suma (łącznie)</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-1">
						<v-card-text></v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center" class="amount"><strong>{{formatMoney(totalMszFundings)}}</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text class="amount"><strong>{{formatMoney(totalOwnFundings)}}</strong></v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text class="amount"><strong>{{formatMoney(totalFundings)}}</strong></v-card-text>
					</v-card>
				</v-flex>
			</v-layout>

			<div class="mt-2">
				<offer-button
					v-if="!readonly"
					text="Dodaj kolejny koszt"
					@click="addCost"
				></offer-button>
			</div>

		</v-form>
		<egranty-validation-error
			:error="error"
		></egranty-validation-error>
	</div>
</template>

<script>
	import OfferButton from "../../offer/components/OfferButton";
	import {AgencyContestParagraph} from "../../../../api/generated/AgencyContestParagraph";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";
	import {Agency} from "../../../../api/generated/Agency";
	import {Numbers} from "../../../../utils/Numbers";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";

	export default {
		name: "AgencyActionsCosts",
		components: {
			EgrantySectionDivider,
			EgrantyValidationError, EgrantyIconButton, EgrantyNumberInputField, EgrantyTextInputField, OfferButton,
		},

		created() {
			if (this.costs.length < 1){
				this.addCost();
			}
		},

		data() {
			return {
				error: '',
				costs: [],
				paragraphs: [],
				currencyCode: 'PLN'
			};
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					if (val === undefined) return;
					this.costs = val;
					this.calculateTotalForParagraph();
				}
			}
		},

		props: {
			readonly: {default: false},
			value: {},
			actions: {},
			contestId: {}
		},

		mixins: [Numbers],

		computed: {

			totalOwnFundings() {
				return this.costs.reduce(function (cnt, o) {
					return isNaN(o.ownFundings) ? cnt : cnt + Number(o.ownFundings);
				}, 0);
			},

			totalMszFundings() {
				return this.costs.reduce(function (cnt, o) {
					return isNaN(o.mszFundings) ? cnt : cnt + Number(o.mszFundings);
				}, 0);
			},

			totalFundings() {
				return this.totalMszFundings + this.totalOwnFundings;
			}
		},

		methods: {
			calculateTotalFundingForCost (cost) {
				let ownFundings = cost.ownFundings === null ? 0 : parseFloat(cost.ownFundings);
				let mszFundings = cost.mszFundings === null ? 0 : parseFloat(cost.mszFundings);
				return Numbers.methods.formatMoney(ownFundings + mszFundings);
			},

			sync() {
				this.$emit('input', this.costs);
				this.error = '';
				this.calculateTotalForParagraph();
			},

			emptyCost() {
				return {
					actionId: null,
					expenseName: null,
					mszFundings: null,
					ownFundings: null,
					paragraphId: null
				};
			},

			async validate() {
				let valid = await this.$validator.validateAll();
				valid &= this.$refs.form.validate();
				return valid === 1;
			},

			removeCost(index) {
				this.costs.splice(index, 1);
				this.sync();
			},

			addCost() {
				this.costs.push(this.emptyCost());
				this.sync();
			},


			loadParagraphs() {
				AgencyContestParagraph.getAllParagraphs(
					this,
					this.contestId,
					response => {
						this.paragraphs = response;
						this.paragraphs.sort(function(a, b)  {
							const nameA = a.name.toUpperCase();
							const nameB = b.name.toUpperCase();
              return nameA > nameB ? 1 : -1;
						});
						this.paragraphs.forEach((paragraph) => {
							this.$set(paragraph, 'arrayId', 'par' + paragraph.id);
							this.$set(paragraph, 'totalMszFundingsForParagraph', 0);
							this.$set(paragraph, 'totalOwnFundingsForParagraph', 0);
						});
						this.calculateTotalForParagraph();
					}
				);
			},

			loadCurrencyCode () {
				if (this.$route.params.agencyId !== undefined) {
					Agency.getCurrencyCodeByAgency(this, this.$route.params.agencyId, successResponse => {
							if (successResponse.currencyCode) this.currencyCode = successResponse.currencyCode;
						},
						errorResponse => {
							this.$messagesBus.$emit("error", "Nie udało się załadować waluty placówki", errorResponse);
						});
				} else {
					Agency.getMyCurrencyCode(this, successResponse => {
							if (successResponse.currencyCode) this.currencyCode = successResponse.currencyCode;
						},
						errorResponse => {
							this.$messagesBus.$emit("error", "Nie udało się załadować waluty placówki", errorResponse);
						});
				}
			},

			calculateTotalForParagraph() {
				this.paragraphs.forEach(
					paragraph => {
						paragraph.totalMszFundingsForParagraph =
							this.costs.reduce(function (cnt, o) {
								if (isNaN(o.mszFundings)) {
									return cnt;
								} else {
									return cnt + (o.paragraphId === paragraph.id ? Number(o.mszFundings) : 0);
								}
							}, 0);
						paragraph.totalOwnFundingsForParagraph =
							this.costs.reduce(function (cnt, o) {
								if (isNaN(o.ownFundings)) {
									return cnt;
								} else {
									return cnt + (o.paragraphId === paragraph.id ? Number(o.ownFundings) : 0);
								}
							}, 0);
						paragraph.totalFundings = paragraph.totalMszFundingsForParagraph + paragraph.totalOwnFundingsForParagraph;
					});
			}
		},

		mounted() {
			this.loadParagraphs();
			this.loadCurrencyCode();
		}
	};
</script>

<style scoped>
	.theme--dark .grey.lighten-5  {
		background-color: #1B1B1B !important;
	}

	.agency-action-costs-v-select-icon {
		display: flex;
		width: 100%;
	}
</style>
